import { BoundingBox } from '@egr/wcf/modules/core/mdl';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { AbstractRoomCommand } from './AbstractRoomCommand';
import { clone as arrClone } from '@egr/wcf/modules/utils/array';
import { GroupElement } from './../mdl/GroupElement';
import { Wall } from '../mdl/Wall';
import { RoomElement } from '../mdl/RoomElement';
export class AbstractGroupUngroupElements extends AbstractRoomCommand {
    constructor(pRoomManager, pElements) {
        super(pRoomManager);
        this.mRoomManager = pRoomManager;
        this.mElements = arrClone(pElements);
        this.mElementsDeleted = false;
        this.mUnGroupChilds = new Array();
        this.mUndoData = new Map();
        this.mGroupsInSelection = true;
        this.checkForGroups();
        //store element and node parents
        this.mElementParents = new Array();
        this.mElementUndoData = new Array();
        this.mNodeParents = new Array();
        for (let tElement of this.mElements) {
            this.mElementParents.push(tElement.getParentElement());
            this.mElementUndoData.push(null);
            this.mNodeParents.push(tElement.node.parent);
        }
    }
    isUndoable() {
        return (true);
    }
    cancel() {
        this.undo();
    }
    get UnGroupChilds() {
        return (this.mUnGroupChilds);
    }
    dispose() {
        if (this.mElementsDeleted) {
            for (let tElement of this.mElements)
                tElement.dispose();
        }
        this.mElements = undefined;
    }
    checkForGroups() {
        let tgroupExists = false;
        for (let tElement of this.mElements) {
            if (tElement instanceof GroupElement) {
                tgroupExists = true;
                break;
            }
        }
        if (!tgroupExists)
            this.mGroupsInSelection = false;
    }
    // tslint:disable-next-line:cyclomatic-complexity
    group(pUndoData) {
        this.mRoomManager.app.commands.beginUndoSection();
        let tSel = new Array();
        let tRes = new Array();
        if (pUndoData === undefined) {
            let t_Sel = this.mApp.model.selection;
            for (let tElement of t_Sel) {
                if (tElement instanceof Wall ||
                    ((tElement instanceof RoomElement) &&
                        (tElement.type === "Floor" || tElement.type === "Rectangle" ||
                            tElement.type === "Circle" || tElement.type === "Spline" ||
                            tElement.type === "Line") &&
                        (tElement.height === 0)))
                    continue;
                tSel.push(tElement);
            }
            if (tSel.length === 0) {
                this.mRoomManager.app.commands.endUndoSection();
                return undefined;
            }
            if (tSel.length === 1 && (tSel[0] instanceof GroupElement)) {
                this.mRoomManager.app.commands.endUndoSection();
                return undefined;
            }
            let tGroupElement = new GroupElement(this.mRoomManager);
            this.mGroupElement = tGroupElement;
            this.mUndoData.set({ groupElement: tGroupElement }, { children: tSel });
        }
        this.mUndoData.forEach((children, entry) => {
            this._group(entry.groupElement, children.children);
            tRes.push(entry.groupElement);
        });
        return (tRes);
    }
    _group(pGroupElement, pChildren) {
        let tTotalBounds = BoundingBox.FromElements(pChildren, true, true);
        let tOrgCenter3d = tTotalBounds.getCenter();
        tOrgCenter3d.y = 0;
        this.mApp.model.addElement(pGroupElement);
        for (let tElement of pChildren) {
            let tChild = tElement;
            tChild.node.position.subtractInPlace(tOrgCenter3d);
            this.mApp.model.removeElement(tChild, false, false);
            this.mApp.model.addElement(tChild, pGroupElement.node);
            pGroupElement.addElement(tChild);
            tChild.getMainElement = () => pGroupElement;
            tChild.notifyChange(ElementChangedFlags.Transformation);
            tChild.updateTransformation();
            tChild.eventPropertiesChanged.addListener(pGroupElement.ElementPropertiesChanged(tChild));
        }
        pGroupElement.node.position = tOrgCenter3d;
        pGroupElement.updateTransformation();
        let tWM = pGroupElement.node.computeWorldMatrix();
        pGroupElement.setTransform(tWM);
        pGroupElement.notifyChange(ElementChangedFlags.BoundingBox);
        pGroupElement.notifyChange(ElementChangedFlags.Transformation);
        this.mApp.model.setSelection([pGroupElement]);
        this.mRoomManager.app.commands.endUndoSection();
    }
    ungroup(pUndoData) {
        this.mRoomManager.app.commands.beginUndoSection();
        let tRes = new Array();
        if (pUndoData === undefined) {
            let t_Sel = arrClone(this.mApp.model.selection);
            for (let tElement of t_Sel) {
                if (tElement instanceof GroupElement) {
                    tRes = tRes.concat(this._ungroupSelection(tElement));
                }
            }
        }
        else {
            this.mUndoData.forEach((children, entry) => {
                tRes = tRes.concat(this._ungroupSelection(entry.groupElement, false));
            });
        }
        this.mApp.model.setSelection([]);
        this.mRoomManager.app.commands.endUndoSection();
        return (tRes);
    }
    //// private ///////////////////////////////////////////////////////////////////////////////
    _ungroupSelection(pElement, pInitial = true) {
        this.mRoomManager.app.commands.beginUndoSection();
        let tGroupElement = pElement;
        let tgroupChildren = arrClone(tGroupElement.elements);
        for (let tChild of tgroupChildren) {
            tGroupElement.removeElement(tChild);
            tChild.node.setParent(null);
            this.mApp.model.addElement(tChild, null);
            this.mApp.model.addToSelection(tChild);
            tChild.updateTransformation();
            tChild.eventTransformationChanged.removeListener(tGroupElement.ElementPropertiesChanged(tChild));
        }
        this.mElements = tgroupChildren;
        this.mApp.model.removeElement(tGroupElement, false, false);
        if (pInitial)
            this.mUndoData.set({ groupElement: tGroupElement }, { children: tgroupChildren });
        this.mRoomManager.app.commands.endUndoSection();
        return (tgroupChildren);
    }
}
export class Group extends AbstractGroupUngroupElements {
    constructor(pRoomManager, pElements) {
        super(pRoomManager, pElements);
    }
    isAvailable() {
        return (this.mElements != null);
    }
    execute(pParameter) {
        this.group();
        return (Promise.resolve(true));
    }
    undo() {
        this.mUnGroupChilds = this.ungroup(this.mUndoData);
        this.mApp.model.setSelection(this.mUnGroupChilds);
        return (Promise.resolve());
    }
    redo() {
        this.group(this.mUndoData);
        return (Promise.resolve());
    }
    get GroupElement() {
        return (this.mGroupElement);
    }
}
export class UnGroup extends AbstractGroupUngroupElements {
    constructor(pRoomManager, pElements) {
        super(pRoomManager, pElements);
    }
    isAvailable() {
        return (this.mElements != null && this.mGroupsInSelection);
    }
    execute(pParameter) {
        this.mUnGroupChilds = this.ungroup();
        this.mApp.model.setSelection(this.mUnGroupChilds);
        return (Promise.resolve(true));
    }
    undo() {
        let tGroups = this.group(this.mUndoData);
        if (tGroups !== undefined)
            this.mApp.model.setSelection(tGroups);
        return (Promise.resolve());
    }
    redo() {
        this.mUnGroupChilds = this.ungroup(this.mUndoData);
        this.mApp.model.setSelection(this.mUnGroupChilds);
        return (Promise.resolve());
    }
}
